module.exports = __webpack_public_path__ + "static/media/Hat_2.0d75cddb.jpg";